import React, { Fragment } from 'react';

import Image from './Image';
import Markdown from './Markdown';

const ImageGrid = ({ component }) => {
  return (
    <>
      <div className="g-row image-grid">
        {component.images.map((image) => {
          switch (image.component) {
            case 'image':
              return (
                <Image
                  key={image._uid}
                  component={{ ...image }}
                  className="image-grid__cell g-row"
                />
              );
            case 'markdown':
              return (
                <Markdown
                  key={image._uid}
                  component={{ ...image }}
                  className={`image-grid__cell g-row ${component.align === 'left' ? 'text--align-left' : 'text--align-right'}`}
                />
              );
            }
        })}
      </div>
    </>
  );
};

export default ImageGrid;
